<template>
  <label class="selectLabel">
    <select
      :name="selectName"
      class="selectOption"
      :value="selected"
      @input="$emit('input', $event.target.value)"
    >
      <option value="hide">Choose the {{nameToLowerCase}}</option>
      <option v-for="(option, index) in options" :key="index" :value="option.value">{{option.text}}</option>
    </select>
  </label>
</template>

<script>
export default {
  name: "Select",
  props: {
    selectName: String,
    options: Array,
    selected: { type: String, default: "hide" }
  },
  computed: {
    nameToLowerCase() {
      return this.selectName.toLowerCase();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables";

.selectOption {
  color: $placeholderColor;
  width: 100%;
  position: relative;
  background-color: #f8f8f9;
  outline: none;
  border: none;
  padding: 8px 38px 8px 8px;
  border-radius: $borderRadius;
  cursor: pointer;

  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: "";
}

.selectLabel {
  width: 100%;
  position: relative;
  margin-bottom: 0;
}

.selectLabel::after {
  font-family: "icomoon" !important;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  content: "\e902";
  color: #00acb3;

  font-size: 8px;
  right: 8px;
  top: 16px;
  padding: 0 0 2px;
  position: absolute;
  pointer-events: none;
}
</style>

